import { render, staticRenderFns } from "./ScadaThreeTabAttributes.vue?vue&type=template&id=54d48b47&"
import script from "./ScadaThreeTabAttributes.vue?vue&type=script&lang=js&"
export * from "./ScadaThreeTabAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports